export default __webpack_public_path__ + "static/media/lock.bfb7e4e8.svg";